import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Sellers',
  baseUrl: '',
  routes: [
    {
      path: '/admin/sellers',
      page: 'SellersPage',
      title: 'Sellers Page',
      exact: true
    },
    {
      path: '/admin/sellers/product',
      page: 'SellerProduct',
      title: 'Product Page',
      exact: true
    },
    {
      path: '/admin/sellers/product/:productId',
      page: 'ProductDetail',
      title: 'Product Detail Page',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
